var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7953 14.242C15.9618 14.9954 18.4576 14.4944 20.186 12.7388C21.9534 10.9436 22.4293 8.33336 21.6136 6.09923L18.6782 9.08071C18.4759 9.28616 18.1978 9.39857 17.9099 9.39126L15.7225 9.33571C15.1566 9.32134 14.7056 8.85699 14.7067 8.28979L14.7108 6.12315C14.7113 5.84933 14.8191 5.58668 15.0111 5.39175L17.9641 2.39242C15.7645 1.56393 13.1945 2.04729 11.427 3.84249C9.81224 5.48258 9.27551 7.80297 9.8168 9.89532L2.60053 17.2248C1.79982 18.0381 1.79982 19.345 2.60053 20.1583L3.80161 21.3782C4.61782 22.2073 5.95304 22.2073 6.76926 21.3782L13.7953 14.242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.d2b7ccea22d6c23207a30ff30ec19988.svg";
export { ForwardRef as ReactComponent };